<div class="consortium-card mb-2">
  <div class="consortium-toggle" *ngIf="showToggle">
    <div class="custom-control custom-checkbox">
      <input
        type="checkbox"
        class="custom-control-input"
        id="consortiumModeCheckbox"
        [checked]="isConsortiumMode"
        (change)="toggleConsortiumMode()"
        [disabled]="loading"
      />
      <label class="custom-control-label" for="consortiumModeCheckbox">
        <span class="toggle-label">Este contrato é um consórcio de empresas</span>
      </label>
    </div>
    <p class="toggle-hint">
      <i class="fa-solid fa-circle-info"></i>
      Ative esta opção se o contrato envolve múltiplas empresas em consórcio.
    </p>
  </div>

  <div class="consortium-content" *ngIf="isConsortiumMode" [class.no-border]="!showToggle">
    <h5 class="consortium-card-title">{{ title }}</h5>

    <div class="consortium-card-content">
      <div class="consortium-form-grid mb-3" *ngIf="!contractId">
        <div class="form-group">
          <label class="form-label">Consórcio</label>
          <select
            class="form-select"
            [ngModel]="selectedConsortiumId"
            (ngModelChange)="onConsortiumChange($event)"
            [ngModelOptions]="{ standalone: true }"
          >
            <option value="">Novo consórcio</option>
            <option *ngFor="let consortium of consortiums" [value]="consortium.id">
              {{ displayConsortium(consortium) }}
            </option>
          </select>
          <small *ngIf="consortiumsLoading" class="text-muted">Carregando consórcios...</small>
        </div>

        <div class="form-group">
          <label class="form-label required">Nome do Consórcio</label>
          <input
            type="text"
            class="form-control"
            placeholder="Ex: Consórcio Lote Norte"
            [ngModel]="consortiumName"
            (ngModelChange)="onConsortiumNameChange($event)"
            [ngModelOptions]="{ standalone: true }"
          />

          <div class="consortium-name-actions">
            <button
              type="button"
              class="btn btn-outline-primary btn-save-consortium-name"
              (click)="saveConsortium()"
              [disabled]="loading || !canSaveConsortiumName"
            >
              SALVAR NOME DO CONSÓRCIO
            </button>
            <span class="consortium-name-hint">
              Você pode editar o nome sem abrir o formulário de empresa.
            </span>
          </div>
        </div>
      </div>

      <p class="consortium-flow-hint" *ngIf="!contractId && !selectedConsortiumId">
        Salve o consórcio para habilitar o cadastro de empresas.
      </p>

      <div class="consortium-summary" *ngIf="members.length > 0 && !formOpen">
        <div class="summary-item">
          <span class="summary-label">Empresas:</span>
          <span class="summary-value">{{ members.length }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Líder:</span>
          <span class="summary-value" [class.text-warning]="!hasLeader">
            {{ hasLeader ? displayCompanyName(members | findLeader) : 'Não definido' }}
          </span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Participação Total:</span>
          <span class="summary-value" [class.text-danger]="!isPercentageValid" [class.text-success]="isPercentageValid">
            {{ totalPercentage | number: '1.0-2' }}%
          </span>
        </div>
      </div>

      <div class="alert-percentage" *ngIf="members.length > 0 && !isPercentageValid && !formOpen">
        <i class="fas fa-exclamation-triangle"></i>
        <span>A soma dos percentuais de participação deve ser igual a 100%.</span>
      </div>

      <div class="consortium-outer-wrapper" *ngIf="formOpen">
        <div class="consortium-form-wrapper">
          <div class="consortium-form-card">
            <form [formGroup]="form">
              <div class="consortium-form-grid">
                <div class="form-group form-group-full" *ngIf="contractId">
                  <label class="form-label required">Nome do Consórcio</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Ex: Consórcio Lote Norte"
                    formControlName="consortiumName"
                    [class.is-invalid]="isInvalid('consortiumName')"
                    (input)="onConsortiumNameChange($event.target.value)"
                  />
                  <span class="invalid-feedback" *ngIf="isInvalid('consortiumName')">
                    {{ errorMessage('consortiumName') }}
                  </span>
                </div>

                <div class="form-group form-group-full">
                  <div class="d-flex align-items-center justify-content-between">
                    <label class="form-label required mb-0">Empresa Contratada</label>
                    <a class="link-nova-empresa" href="#/contracted-company" target="_blank">
                      <i class="fas fa-plus"></i>
                      Cadastrar nova empresa
                    </a>
                  </div>
                  <select
                    class="form-select"
                    formControlName="contractedCompanyId"
                    [class.is-invalid]="isInvalid('contractedCompanyId') || duplicateError"
                    (change)="onCompanyChange()"
                  >
                    <option value="" disabled>Selecione uma empresa</option>
                    <option *ngFor="let company of contractedCompanies" [value]="company.id">
                      {{ displayContractedCompany(company) }}
                    </option>
                  </select>
                  <span class="invalid-feedback" *ngIf="isInvalid('contractedCompanyId')">
                    {{ errorMessage('contractedCompanyId') }}
                  </span>
                  <small *ngIf="contractedCompaniesLoading" class="text-muted">
                    Carregando empresas...
                  </small>
                </div>

                <div class="form-group">
                  <label class="form-label">Função no Consórcio</label>
                  <div class="custom-control custom-checkbox leader-checkbox">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="isLeaderCheckbox"
                      formControlName="isLeader"
                      (change)="onLeaderChange()"
                    />
                    <label class="custom-control-label" for="isLeaderCheckbox">
                      Empresa Líder do Consórcio
                    </label>
                  </div>
                </div>

                <div class="form-group">
                  <label class="form-label required">Participação (%)</label>
                  <div class="input-group-percentage">
                    <input
                      type="number"
                      class="form-control"
                      placeholder="0"
                      formControlName="participationPercentage"
                      [class.is-invalid]="isInvalid('participationPercentage')"
                      min="0"
                      max="100"
                      step="0.01"
                    />
                    <span class="input-suffix">%</span>
                  </div>
                  <span class="invalid-feedback" *ngIf="isInvalid('participationPercentage')">
                    {{ errorMessage('participationPercentage') }}
                  </span>
                </div>
              </div>

              <div class="alert-duplicate" *ngIf="duplicateError">
                <i class="fas fa-exclamation-circle"></i>
                <span>Esta empresa já faz parte do consórcio.</span>
              </div>

              <div class="alert-duplicate" *ngIf="leaderError">
                <i class="fas fa-exclamation-circle"></i>
                <span>O consórcio já possui uma empresa líder. Edite a empresa líder atual ou desmarque esta opção.</span>
              </div>

              <p class="form-warning">
                <strong>Aviso:</strong> Cada empresa só pode aparecer uma vez no consórcio.
                A soma dos percentuais de participação deve ser igual a 100%.
              </p>

              <div class="d-flex align-items-center" style="margin-top: 20px; gap: 8px;">
                <button
                  type="button"
                  class="btn btn-primary"
                  (click)="save()"
                  [disabled]="loading"
                >
                  {{ contractId ? 'SALVAR EMPRESA NO CONTRATO' : 'SALVAR EMPRESA NO CONSÓRCIO' }}
                </button>
              </div>
            </form>
          </div>

          <div class="consortium-form-side-actions">
            <div class="btn-side-action-wrapper">
              <button
                type="button"
                class="btn-side-action btn-cancel"
                (click)="cancel()"
                [disabled]="loading"
                title="Cancelar"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>
            <div class="btn-side-action-wrapper">
              <button
                type="button"
                class="btn-side-action btn-clear"
                (click)="clearForm()"
                [disabled]="loading"
                title="Limpar formulário"
              >
                <i class="fas fa-eraser"></i>
              </button>
            </div>
          </div>
        </div>

        <p class="alert-draft" *ngIf="isDraftMode && members.length > 0">
          Você está criando empresas em rascunho. Elas serão vinculadas ao contrato quando ele for salvo.
        </p>
      </div>

      <p class="alert-draft" *ngIf="isDraftMode && members.length > 0 && !formOpen">
        Você está criando empresas em rascunho. Elas serão vinculadas ao contrato quando ele for salvo.
      </p>

      <div class="consortium-table-wrapper" *ngIf="members.length > 0 && !formOpen">
        <table class="consortium-table">
          <thead>
            <tr>
              <th>Empresa</th>
              <th>CNPJ</th>
              <th>Função</th>
              <th>Participação</th>
              <th class="col-actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let member of displayedMembers; trackBy: trackById">
              <td>
                <div class="company-name">
                  {{ displayCompanyName(member) }}
                </div>
              </td>
              <td>{{ displayCompanyCnpj(member) }}</td>
              <td>
                <span class="badge" [class.badge-leader]="member.isLeader" [class.badge-partner]="!member.isLeader">
                  {{ member.isLeader ? 'Líder' : 'Consorciada' }}
                </span>
              </td>
              <td>{{ member.participationPercentage | number: '1.0-2' }}%</td>
              <td class="col-actions">
                <div class="dropdown" dropdown placement="bottom right" container="body">
                  <button class="btn-menu" dropdownToggle [disabled]="loading">
                    <i class="fa-solid fa-ellipsis-vertical"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
                    <li>
                      <button class="dropdown-item" (click)="openEdit(member)">Editar</button>
                    </li>
                    <li>
                      <button class="dropdown-item text-danger" (click)="openRemoveModal(member)">
                        Excluir
                      </button>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="consortium-table-footer" *ngIf="members.length > initialDisplayCount">
          <button
            type="button"
            class="btn-ver-mais"
            [class.expanded]="showAll"
            (click)="toggleShowAll()"
          >
            <i class="fas fa-chevron-down"></i>
            {{ showAll ? 'VER MENOS' : 'VER MAIS' }}
          </button>
        </div>
      </div>

      <button
        type="button"
        class="btn-nova-empresa"
        (click)="openCreate()"
        [disabled]="loading || formOpen || (!contractId && !selectedConsortiumId)"
      >
        <i class="fas fa-plus-circle"></i>
        ADICIONAR EMPRESA
      </button>

      <div class="consortium-loading" *ngIf="loading && !formOpen">
        <div class="spinner"></div>
      </div>
    </div>
  </div>
</div>

<ng-template #confirmRemoveTpl>
  <div class="modal-header">
    <h5 class="modal-title">Confirmar remoção</h5>
    <button
      type="button"
      class="modal-close"
      aria-label="Fechar"
      (click)="closeRemoveModal()"
      [disabled]="loading"
    >
      &times;
    </button>
  </div>

  <div class="modal-body">
    <p>Tem certeza que deseja remover esta empresa do consórcio?</p>

    <div class="member-preview" *ngIf="memberPendingDelete">
      <div class="member-preview-header">
        <strong>{{ displayCompanyName(memberPendingDelete) }}</strong>
        <span class="separator"> • </span>
        <span>{{ displayCompanyCnpj(memberPendingDelete) }}</span>
      </div>
      <div class="member-preview-details">
        <span>
          Função: <strong>{{ memberPendingDelete.isLeader ? 'Líder' : 'Consorciada' }}</strong>
        </span>
        <span class="separator"> | </span>
        <span>
          Participação: <strong>{{ memberPendingDelete.participationPercentage | number: '1.0-2' }}%</strong>
        </span>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="closeRemoveModal()"
      [disabled]="loading"
    >
      Cancelar
    </button>
    <button
      type="button"
      class="btn btn-danger"
      (click)="confirmRemove()"
      [disabled]="loading"
    >
      <span *ngIf="loading" class="spinner-border spinner-border-sm"></span>
      {{ loading ? 'Removendo...' : 'Remover' }}
    </button>
  </div>
</ng-template>
